import React from 'react';
import { LoginSignupLayout }
  from '@fuww/library/src/Login';
import Hr from '@fuww/library/src/Elements/Hr';
import Divider from '@fuww/library/src/Login/Divider';
import Button from '@fuww/library/src/Button';
import { useIntl } from 'react-intl';
import PropTypes, { InferProps } from 'prop-types';
import { useTheme } from '@emotion/react';
import LoginForm from './LoginForm';
import LoginWithProviderForm from './LoginWithProviderForm';
import Disclaimer from './Disclaimer';
import Head from '../Head';
import HomeLink from '../HomeLink';
import LinkAndAnchor from '../LinkAndAnchor';
import { Link } from '../../routes.mjs';
import CookieConsentMessage from '../CookieConsent/Message';
import messages from '../../lib/messages.json';
import RedirectWhenLoggedIn from './RedirectWhenLoggedIn';

const loginPropertyTypes = {
  showBreadcrumbs: PropTypes.bool,
};

type LoginProperties = InferProps<typeof loginPropertyTypes>;

const Login = ({ showBreadcrumbs }: LoginProperties) => {
  const intl = useIntl();
  const theme = useTheme();

  const breadcrumbs = (showBreadcrumbs ?? true) ? [
    <HomeLink />,
    <LinkAndAnchor
      route="login"
    >
      {intl.formatMessage(messages.login)}
    </LinkAndAnchor>,
  ] : [];

  return (
    <LoginSignupLayout
      title={intl.formatMessage(messages['login.title'])}
      disclaimer={(<Disclaimer />)}
      breadcrumbs={breadcrumbs}
    >
      <Head
        title={intl.formatMessage(messages['login.title'])}
        description={
          intl.formatMessage(messages['markets.description'])
        }
      />
      <CookieConsentMessage />
      <LoginForm />
      <Divider dividerText="OR CONTINUE WITH" />
      <LoginWithProviderForm
        provider="google"
      />
      <LoginWithProviderForm
        provider="linkedin"
      />
      <Link route="register" passHref>
        <Button fullWidth variant="text" className="create-account">
          {intl.formatMessage(messages['register.createAccount'])}
        </Button>
      </Link>
      <Hr backgroundColor={theme.colors.blackDisabled} margin="24px 0" />
      <RedirectWhenLoggedIn />
    </LoginSignupLayout>
  );
};

Login.propTypes = loginPropertyTypes;

export default Login;
